/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */


import G17Client from '../services/G17Client';
import { createGenericSlice } from './slice';
import { RootInitiativeData } from '../types/initiative';
import type { AppDispatch, RootState } from '../reducers';


const name = 'rootInitiatives' as const;
const rootInitiativeListSlice = createGenericSlice<RootInitiativeData[]>({
  name,
  initialState: { data: [], loaded: false, loading: false },
  reducers: {},
})


const { load, loaded, error } = rootInitiativeListSlice.actions;
export default rootInitiativeListSlice.reducer;


const loadFromApi = (dispatch: AppDispatch) => {
  G17Client.loadRootInitiatives()
    .then((data) => {
      dispatch(loaded(data))
    })
    .catch((err: Error) => {
      dispatch(error(err));
    })
};

export const loadRootInitiatives = () => async (dispatch: AppDispatch, getState: () => RootState) => {
  const state = getState()[name];
  if (state.loading || state.loaded) {
    return;
  }
  dispatch(load());
  loadFromApi(dispatch);
}

export const reloadRootInitiatives = (blocking = false) => async (dispatch: AppDispatch, getState: () => RootState) => {
  if (getState()[name].loading) {
    return;
  }
  if (blocking) {
    dispatch(load());
  }
  loadFromApi(dispatch);
}
